import { defineMessages } from 'react-intl';

export const spotlightMessages: {
	spotlightHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	spotlightBody: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	spotlightTellMeMore: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	spotlightDismiss: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tellMeMoreAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	spotlightHeading: {
		id: 'jira-nin-list-merge-spotlight-onboarding.spotlight.heading',
		defaultMessage: "We've merged List and All Work views",
		description: 'Heading for the list merge spotlight',
	},
	spotlightBody: {
		id: 'jira-nin-list-merge-spotlight-onboarding.spotlight.body',
		defaultMessage:
			"We've merged the best of List and All Work into a faster, accessible experience.",
		description: 'Body for the list merge spotlight',
	},
	spotlightTellMeMore: {
		id: 'jira-nin-list-merge-spotlight-onboarding.spotlight.tell-me-more',
		defaultMessage: 'Tell me more',
		description: 'Tell me more button for the list merge spotlight',
	},
	spotlightDismiss: {
		id: 'jira-nin-list-merge-spotlight-onboarding.spotlight.dismiss',
		defaultMessage: 'Dismiss',
		description: 'Dismiss button for the list merge spotlight',
	},
	tellMeMoreAriaLabel: {
		id: 'jira-nin-list-merge-spotlight-onboarding.spotlight.tell-me-more-aria-label',
		defaultMessage: 'Read our community post about the merge of List and All Work views',
		description: 'Aria label for the tell me more button for the list merge spotlight',
	},
});
